import {type ViewProductDetailsQuery} from "../graphql";

import type {ComputedRef} from "vue";
import {computed} from "vue";

type ProductDetails = Extract<
	ViewProductDetailsQuery["product"],
	{__typename: "SimpleProduct"}
>;

export type OutletData = {
	outlet: {
		id: string;
		title: string;
	};
	availableQuantity: number;
	modelQuantity: number;
};

export type ReturnData = {
	outlets: ComputedRef<OutletData[]>;
	fetching: ComputedRef<boolean>;
};

/** Simply read the appropriate (bundled, if applicable) product stock data. `productDetails` should have been fetched with outlet bundling included. */
export function useOutletStocks(
	productDetails: ComputedRef<ProductDetails | undefined>,
): ReturnData {
	const bundledStocks = computed(() => {
		if (!productDetails.value) {
			return [];
		}
		if (!productDetails.value.outletsWithBundling) {
			return productDetails.value.outlets;
		}
		return productDetails.value.outletsWithBundling;
	});

	const result = computed(() => {
		const stocks = [...bundledStocks.value];
		stocks.sort((a, b) => a.outlet.title.localeCompare(b.outlet.title));
		return stocks;
	});

	return {
		outlets: result,
		fetching: computed(() => !productDetails.value),
	};
}
